import React from "react"
import { Box } from "@mui/material"

import { LockingSystemRowConfigurationHeaders } from "./LockingSystemRowConfigurations/LockingSystemRowConfigurations"
import StyledLockingSystemCell from "./StyledLockingSystemCell"

const LockingSystemMatrixHeader = () => {
	const gridRowName = "matrixHeader"

	return (
		<>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="position">
				<Box ml={1} mt={1} style={{ color: "grey" }}>
					Pos.
				</Box>
			</StyledLockingSystemCell>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="actions">
				{" "}
			</StyledLockingSystemCell>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="doorName">
				<Box mt={1} style={{ textAlign: "center", color: "grey" }}>
					Türname
				</Box>
			</StyledLockingSystemCell>
			<StyledLockingSystemCell gridRowName={gridRowName} gridColumnName="lockingComponent">
				<Box mt={1} style={{ textAlign: "center", color: "grey" }}>
					Zylinder
				</Box>
			</StyledLockingSystemCell>
			<LockingSystemRowConfigurationHeaders />
		</>
	)
}

export default LockingSystemMatrixHeader
